import React, { FC } from 'react'

import { ProfileItem } from 'api/search/search.types'
import { SearchItemPromo, SearchPromoTypes } from 'common-constants/promoCases'
import { ProfileCardLegacy } from 'components/page/Search/SearchItem/ProfileCardLegacy'
import { SearchListPromoLegacy } from 'components/page/Search/SearchListPromoLegacy'

export const ItemSwitcherLegacy: FC<{
  item: ProfileItem | SearchItemPromo
  itemIndex: number
  getNearElementByIndex: Function
}> = ({ item, itemIndex, getNearElementByIndex }) => {
  switch (item.type) {
    case SearchPromoTypes.Service:
      return (
        <SearchListPromoLegacy
          item={item}
          getNearElement={() => getNearElementByIndex(itemIndex)}
        />
      )
    default:
      return <ProfileCardLegacy item={item as ProfileItem} />
  }
}
